import { HttpClient } from '@angular/common/http';
import { Inject } from '@angular/core';
import { CrudService, ENVIRONMENT, HateoasMultipleResponseObject, PageSpecification, ReportOutputFormat, ReportRunService, ReportSpecification, ReportSpecificationService, addPageSpecificationParameters, appendSerialisedHttpParams } from '@scisys-uim/uim-common';
import { FIREARM_TYPE, Firearm } from 'assets-model';
import { Observable } from 'rxjs';



export abstract class FirearmServiceBase extends CrudService<Firearm, number> {

  servicePath: string = '/firearm';

  exportReportName: string = 'firearm-export';
  exportReportUrl: string = '/exportByFullFilters';

  constructor(protected http: HttpClient, 
      @Inject(ENVIRONMENT) protected environment: any,
    protected reportRunService: ReportRunService,
    protected reportSpecificationService: ReportSpecificationService) {
    super(http, environment, FIREARM_TYPE.entityDecorator);
  }

  public findByFullFilters(filters: any, pageSpec?: PageSpecification, reduced: boolean = true): Observable<HateoasMultipleResponseObject<Firearm>> {
    var params = appendSerialisedHttpParams(filters);
	
    params = appendSerialisedHttpParams(reduced, 'reduced', params);

    if (pageSpec) {
      params = addPageSpecificationParameters(pageSpec, params);
    }
	
    return this.deserialiseMultipleResponse(this.http.get<HateoasMultipleResponseObject<Firearm>>(this.serviceBaseUrl + (pageSpec ? '/findByFullFilters' : '/findByFullFiltersUnpaged'), {
      params: params
    }));
  }

  public exportByFullFiltersAction(filters: any, outputFormat: ReportOutputFormat, download: boolean, pageSpec?: PageSpecification) {
    var httpParams = appendSerialisedHttpParams(filters);
    if (pageSpec) {
      httpParams = addPageSpecificationParameters(pageSpec, httpParams);
    }
    httpParams = this.reportRunService.reportGeneralHttpParams(outputFormat, download, httpParams);
    return this.reportRunService.reportAction(this.serviceBaseUrl + this.exportReportUrl, httpParams);
  }

  public exportReportSpecification(): Observable<ReportSpecification> {
    return this.reportSpecificationService.get(this.exportReportName);
  }
}



